module.exports = __webpack_public_path__ + "static/media/full_avatar.b54eb52c.png";